<template>
	<div>

		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@Currentchange="contractlistcontractlist" style="margin: 1rem;"></MyTable>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import MyDialog from "@/components/My_dialog/index.vue"
	import {
		look_meters_num,
		meters_switch_action
	} from "@/api/api.js"
	export default {
		props: [
			"item"
		],
		data() {
			return {
				name: 'Intelligent_ViewHistory',
				tableData: [],
				table_label: [{
					label: 'ID',
					value: 'id'
				}, {
					label: '当前剩余',
					value: 'residue'
				}, {
					label: '当前累计',
					value: 'total'
				}, {
					label: '当前读数',
					value: 'reading'
				}, {
					label: '备注',
					value: 'remark'
				}, {
					label: '抄表时间',
					value: 'create_time'
				}, ],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					device_no: '',
					type: 10,
					limit: 15
				},
				room_num: ''
			}
		},
		methods: {
			contractlistcontractlist(value) {
				this.data.page = value ? value : this.data.page
				look_meters_num(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {
						this.tableData = res.data.list
						this.total = res.data.total

					}
				})
			}
		},
		components: {
			MyTable
		},
		created() {
			var value = JSON.parse(JSON.stringify(this.item));
			this.data.device_no = value.device_no
			this.data.type = value.device_type
			this.contractlistcontractlist()
			this.room_num = value.room_num
			console.log('this.item', this.item);
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				var value = JSON.parse(JSON.stringify(this.item));
				this.data.device_no = value.device_no
				this.data.type = value.device_type
				this.room_num = value.room_num
				this.contractlistcontractlist()
			}
		}
	}
</script>

<style scoped>
	.tenant_search {
		display: flex;
		align-items: center;
		background-color: var(--cont_backgound);
		margin: 1.25rem;
		padding: 10px;
		border-radius: 8px;
	}

	::v-deep .el-input__inner:focus {
		border: 1px solid #3C46FF;
	}

	.tenant_search_1 {
		display: flex;
		align-items: center;

	}

	.tenant_search_1 span {
		width: 2.6rem;

	}

	.tenant_search .tenant_search_1:first-child i {
		margin-left: 0rem;
	}

	.tenant_search_1 i {
		height: 1.25rem;
		width: 0.375rem;
		background-color: #3C46FF;
		border-radius: 0.625rem;
		margin: 0 0.625rem;
		margin-left: 1rem;
	}

	.tenant_search :nth-child(2) span {
		width: 4.8rem;
	}


	.tenant_search_1 .el-input {
		width: 10rem;
	}

	.search_button {
		font-size: 0.85rem;
		height: 2rem;
		width: 5rem;
		margin: 0 0.625rem;
		background-color: #409eff;
		border: #409eff;
		color: #fff;
		border-radius: 6px;
	}

	.search_button:hover {
		opacity: 0.8;
	}
</style>